module.exports = __webpack_public_path__ + "static/no_data.a2f369ee.png";